import { ChevronDown } from 'lucide-react';
import type { MouseEvent } from 'react';

import { VoidLink } from '@/src/components/Link/VoidLink';
import type { Props as LinkProps } from '@/src/components/Link/VoidLink';

import { useDropdownContext } from './context';

export type Props = LinkProps;

export function Button({
    children,
    className,
    disabled,
    iconClassName,
    iconLeft,
    iconRight = ChevronDown,
    onClick,
    labelClassName,
}: Props) {
    const { dropdownId, isOpen, setTriggerReference, toggle, triggerId } = useDropdownContext();

    function handleClick(event: MouseEvent<HTMLButtonElement>) {
        toggle();

        if (onClick) {
            onClick(event);
        }
    }

    return (
        <VoidLink
            aria-controls={isOpen ? dropdownId : undefined}
            aria-expanded={isOpen}
            aria-haspopup
            className={className}
            disabled={disabled}
            ref={setTriggerReference}
            iconClassName={iconClassName}
            iconLeft={iconLeft}
            iconRight={iconRight}
            id={triggerId}
            onClick={handleClick}
            labelClassName={labelClassName}
        >
            {children}
        </VoidLink>
    );
}
